import { render, staticRenderFns } from "./ImageWatermark.vue?vue&type=template&id=322a9bc8&scoped=true"
import script from "./ImageWatermark.vue?vue&type=script&lang=js"
export * from "./ImageWatermark.vue?vue&type=script&lang=js"
import style0 from "./ImageWatermark.vue?vue&type=style&index=0&id=322a9bc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322a9bc8",
  null
  
)

export default component.exports